'use client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { flexRender, Table as TableProps } from '@tanstack/react-table';

interface ITable<TData> {
  table: TableProps<TData>;
  loading?: boolean;
}

export const TableComponent = <TData,>({ table, loading }: ITable<TData>) => {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader className="table-header-group">
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow className="table-row" key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <TableHead
                  key={header.id}
                  className={
                    header.column.id === 'select'
                      ? 'w-9 p-1 md:w-10 md:px-2'
                      : undefined
                  }
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </TableHead>
              ))}
            </TableRow>
          ))}
        </TableHeader>

        <TableBody>
          {loading
            ? Array.from({ length: table.getState().pagination.pageSize }).map(
                (_, index) => (
                  <TableRow key={index} className="table-row animate-pulse">
                    {table.getAllColumns().map((col) => (
                      <TableCell
                        key={col.id}
                        className={`h-[57px] ${
                          col.id === 'select' ? 'w-9 p-1 md:w-10 md:px-2' : ''
                        }`}
                      >
                        <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                      </TableCell>
                    ))}
                  </TableRow>
                )
              )
            : table.getRowModel().rows.map((row) => (
                <TableRow
                  key={row.id}
                  className="table-row"
                  data-state={row.getIsSelected() && 'selected'}
                >
                  {row.getVisibleCells().map((cell) => (
                    <TableCell
                      key={cell.id}
                      className={`py-3 ${
                        cell.column.id === 'select'
                          ? 'w-9 p-1 md:w-10 md:px-2'
                          : 'min-w-full'
                      }`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
        </TableBody>
      </Table>
    </div>
  );
};
